module.exports = __webpack_public_path__ + "media/Notifikasi-Kanggo.b2aebb30.mp3";